import React from "react";
import "../BooksGallery.css";

const BooksGallery = () => {
  // ✅ Define your books here — using PUBLIC_URL ensures paths work in production
  const books = [
    {
      title: "The Power of Thought",
      image: process.env.PUBLIC_URL + "/images/50States.jpg",
      pdf: process.env.PUBLIC_URL + "/books/MEDITATIVE_EXPERIENCES.pdf",
    },
    {
      title: "Path to Inner Peace",
      image: process.env.PUBLIC_URL + "/images/50States.jpg",
      pdf: process.env.PUBLIC_URL + "/books/MEDITATIVE_EXPERIENCES.pdf",
    },
    {
      title: "Meditation for Everyone",
      image: process.env.PUBLIC_URL + "/images/50States.jpg",
      pdf: process.env.PUBLIC_URL + "/books/MEDITATIVE_EXPERIENCES.pdf",
    },
  ];

  // ✅ Function to open the PDF in new tab
  const openPDF = (pdfUrl) => {
    try {
      const newWindow = window.open(pdfUrl, "_blank", "noopener,noreferrer");
      if (!newWindow) {
        // If popup blocked, fallback to redirect
        window.location.href = pdfUrl;
      }
    } catch (error) {
      console.error("Error opening PDF:", error);
    }
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📚 Meditation Books</h2>
      <div className="books-grid">
        {books.map((book, index) => (
          <div
            key={index}
            className="book-card"
            onClick={() => openPDF(book.pdf)}
          >
            <img
              src={book.image}
              alt={book.title}
              className="book-image"
              loading="lazy"
            />
            <p className="book-title">{book.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BooksGallery;
